/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentLocations.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Location API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, May 13, 2019 - 04:47:35 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      07/07/2019  NJN     Added Location Cities
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const LocationStates = {
    all: (countryid) => requests.get(`/States?countryid=${countryid}`),
    get: stateid => requests.get(`/State/${stateid}`),
    create: state => requests.post(`/States`, state),
    update: (stateid, state) => requests.put(`/State/${stateid}`, state),
    delete: stateid => requests.del(`/State/${stateid}`),
};

export const LocationCountries = {
    all: () => requests.get('/LocationCountries'),
    get: locationcountryid => requests.get(`/LocationCountry/${locationcountryid}`),
    create: locationcountry => requests.post(`/LocationCountries`, locationcountry),
    update: (locationcountryid, locationcountry) => requests.put(`/LocationCountry/${locationcountryid}`, locationcountry),
    delete: locationcountryid => requests.del(`/LocationCountry/${locationcountryid}`),
};

export const LocationCounties = {
    all: (countryid, stateid) => requests.get(`/LocationCounties?countryid=${countryid}&stateid=${stateid}`),
    get: locationcountyid => requests.get(`/LocationCounty/${locationcountyid}`),
    create: locationcounty => requests.post(`/LocationCounties`, locationcounty),
    update: (locationcountyid, locationcounty) => requests.put(`/LocationCounty/${locationcountyid}`, locationcounty),
    delete: locationcountyid => requests.del(`/LocationCounty/${locationcountyid}`),
};

export const LocationZipCodes = {
    all: (countryid, stateid, countyid, format) => requests.get(`/LocationZipCodes?countryid=${countryid}&stateid=${stateid}&countyid=${countyid}&format=${format}`),
    get: locationzipcodeid => requests.get(`/LocationZipCode/${locationzipcodeid}`),
    create: locationzipcode => requests.post(`/LocationZipCodes`, locationzipcode),
    update: (locationzipcodeid, locationzipcode) => requests.put(`/LocationZipCode/${locationzipcodeid}`, locationzipcode),
    delete: locationzipcodeid => requests.del(`/LocationZipCode/${locationzipcodeid}`),
};

export const LocationCities = {
    all: (countryid, stateid, format) => requests.get(`/LocationCities?countryid=${countryid}&stateid=${stateid}&format=${format}`),
    get: locationcityid => requests.get(`/LocationCity/${locationcityid}`),
    create: locationcity => requests.post(`/LocationCities`, locationcity),
    update: (locationcityid, locationcity) => requests.put(`/LocationCity/${locationcityid}`, locationcity),
    delete: locationcityid => requests.del(`/LocationCity/${locationcityid}`),
};